import React, { Dispatch } from 'react';
import Translator from '../../../core/i18n';
import { Log } from 'ng2-logger';
import { Common } from '../../../core/common';
import { IAction, IAppState } from '../../../models/action/core';
import { connect } from 'react-redux';
import * as Actions from '../../../store/actions/coursePage';
import { IActivityFilters } from '../../../models/action/coursePage';
import { CourseContentMenuType } from '../../../models/enums/CourseContentMenuType';
import { CoursePageService } from '../../../api/course-page-service';
import {  IActivityCardItems } from '../../../models/components/activity-card';
import { ILessonPageClassInformation } from '../../../models/pages/coursePage';
import { UserType } from '../../../models/enums/userType';
import { Redirect } from 'react-router-dom';
import { CourseDefaultViewType } from '../../../models/enums/CourseDefaultViewType';

const _logger = Log.create('ActivityCardMain.tsx');
const T = Translator.create();
let _common: Common;
const coursePageService = new CoursePageService();
let active = 0;
const _lodash = require('lodash');

interface IActivityFiltersProps {
    dispatch?: any;
    passiveButton?: boolean;
    userType?: UserType;
    coursePageClassId?: string;
    coursePageActivityId?: string;
    activityIdAfterAdd?: string;
    courseContentMenuType?: CourseContentMenuType;
    fullName?: string | null;
    profileImagePath?: string;
    userId?: string;
    photoKey?: string | null;
    weekOrUnitId?: string | null | undefined;
    courseContentTermWeeks?: Array<{ notWeekly: boolean, notWeeklyName: string | null, termId: string | null, termWeekId: string | null, week: number | null, endDate: Date | null, startDate: Date | null, itemGuid: string, genaralActivity: boolean, status: number }> | null;
    activityCardItems?: Array<IActivityCardItems>;
    coursePageClassInformation?: ILessonPageClassInformation | null;
    messages?: any;
    sort?: string | null;
    courseDefaultView?: CourseDefaultViewType | null;
    loaded?: boolean | null;
    onFilter?:any;
}

interface IActivityFiltersState {
    sorting: string;
    isLoading: boolean;
    isFirstLoad: boolean;
    passiveButton: boolean;
    statusFilter: number;
    redirectMessagesPage: boolean;
    selectedTeacherId: string;
    selectedTeacherName: string;
    weeklyTerm?: boolean | null;
    nonWeeklyCourse?: boolean | null;
}


class ActivityFilters extends React.Component<IActivityFiltersProps, IActivityFiltersState> {

    constructor(props: any) {
        super(props);
        _common = new Common();

        this.state = {
   
            sorting: this.props.sort ?? '-',
            isLoading: false,
            isFirstLoad: true,
            passiveButton: false,
            statusFilter: -1,
            redirectMessagesPage: false,
            selectedTeacherId: '',
            selectedTeacherName: '',
            weeklyTerm: this.props.courseContentTermWeeks && this.props.courseContentTermWeeks.length > 1,
            nonWeeklyCourse: this.props.courseContentTermWeeks && this.props.courseContentTermWeeks.length === 1
        };

    }

    

    componentDidMount() {
        if (this.props.courseContentTermWeeks) {
            if (this.props.courseContentTermWeeks.length > 1) {
                this.setState({ weeklyTerm: true })

            }
            else if (this.props.courseContentTermWeeks.length === 1) {
                this.setState({ nonWeeklyCourse: true })

            }
        }
        if (this.props.courseDefaultView && this.props.courseDefaultView === CourseDefaultViewType.List && !this.props.loaded && this.state.weeklyTerm) {
            this.props.onFilter()
            // this.setState({ sorting: this.props.courseActivityViewType! });
        }
    }



    public getActivitiesCallback = () => {
        this.props.dispatch(Actions.getActivityIdsByWeeks(this.props.coursePageClassId!, '', false, 'getActivityIdsByWeeks', 'get', undefined, false, this.props.coursePageActivityId ?? ""))
    }

   
    nextOne = () => {
        if (this.props.coursePageClassInformation!.teachers!.length - 1 !== active)
            active = active + 1;
        else
            active = 0;

        this.setState(this.state);
    }

    public async onMessageClick(selectedTeacher: any) {
        this.setState({
            redirectMessagesPage: !this.state.redirectMessagesPage,
            selectedTeacherId: selectedTeacher.userId,
            selectedTeacherName: selectedTeacher.teacherName
        });
    }



    public render() {
                
        if (this.state.redirectMessagesPage) {
            return <Redirect push={true} to={window.appSettings.DEFAULT_URL + '/u/Message/Index/?userId=' + this.state.selectedTeacherId+'&userName=' + this.state.selectedTeacherName} />
        }
        let teacherAvatar = ''
        let teacherId = ''
        if (this.props.coursePageClassInformation && this.props.coursePageClassInformation!.teachers && this.props.coursePageClassInformation!.teachers.length > 0) {
            teacherAvatar = this.props.coursePageClassInformation!.teachers && this.props.coursePageClassInformation!.teachers[active].profileImagePath;
            teacherId = this.props.coursePageClassInformation!.teachers && this.props.coursePageClassInformation!.teachers[active].userId
        }
        return (
            <div className='white-box shadow p-3 responsive-padding '>
                {this.props.courseContentMenuType === CourseContentMenuType.weekAndActivity || this.props.courseContentMenuType === CourseContentMenuType.weekAndActivityStory || this.props.courseContentMenuType === CourseContentMenuType.week ? (
                    <>
                        {!_lodash.isEmpty(teacherId) ?
                            <div className="teacher-details">
                                <div className="teacher_profile_img">
                                    <img onError={(e) => _common.OnErrorImageSrc(e, "avatar")} src={teacherAvatar} alt="" />
                                </div>
                                <div className="teacher_info">
                                    <span className="teacher_name" tabIndex={0} onKeyDown={event => {
                                        if (event.key === 'Enter') {
                                            this.nextOne();
                                        }
                                    }}>{this.props.coursePageClassInformation!.teachers && this.props.coursePageClassInformation!.teachers[active].teacherName}</span>
                                    {!_lodash.isEqual(teacherId, this.props.userId) ?
                                       <button className='message_btn alms-btn btn-default btn-icon' onClick={() => this.onMessageClick(this.props.coursePageClassInformation!.teachers && this.props.coursePageClassInformation!.teachers[active])}>
                                            <img src={_common.GetDefaultIcons('messageoutline')} /><span className='send_message'>{T.t('r_send_message')}</span>
                                        </button>
                                        : null}
                                </div>
                                {this.props.coursePageClassInformation!.teachers && this.props.coursePageClassInformation!.teachers!.length > 1 ?
                                <button className='more_teacher'
                                        onKeyDown={event => {
                                            if (event.key === 'Enter') {
                                                this.nextOne();
                                            }
                                        }}
                                        tabIndex={0}
                                        onClick={() => this.nextOne()}>
                                        <i className="material-icons">chevron_right</i>
                                    </button>: null}
                            </div>
                            :
                            <div className="align-items-center text-center justify-content-center mt-2" style={{ color: 'gray' }}>
                                {T.t('r_no_instructors_added_branch')}
                            </div>
                        }
                    </>
                ) : ''}
            </div>
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: IActivityFiltersProps): IActivityFiltersProps => {
    if (!state) {
        return ownProps;
    }
    const newProps: IActivityFiltersProps = Object.assign({}, ownProps, {
        coursePageActivityId: state.coursePage.coursePageActivityId,
        coursePageClassId: state.coursePage.coursePageClassId,
        activityIdAfterAdd: state.coursePage.activityIdAfterAdd,
        courseContentMenuType: state.coursePage.courseContentMenuType,
        profileImagePath: state.login.identitiy.profileImagePath,
        userId: state.login.identitiy.userId,
        photoKey: state.profile.photoKey,
        fullName: state.login.identitiy.fullName,
        courseContentTermWeeks: state.coursePage.courseContentTermWeeks,
        coursePageClassInformation: state.coursePage.coursePageclassInformation,
        sort: state.coursePage.courseSortingKey,
        weekOrUnitId: state.coursePage.weekOrUnitId,
        userType: state.login.identitiy.userType,
        activityCardItems: state.coursePage.activityCard,
        passiveButton: state.coursePage.isPassiveButton,
        courseDefaultView: state.coursePage.courseDefaultView
    });
    return newProps;
};

const dispatchProps = (dispatch: Dispatch<IAction>) => {
    return ({
        dispatch
    });
};

const areStatesEqual = (next: IAppState, prev: IAppState) => {
    const ret = (
        next.coursePage.coursePageActivityId === prev.coursePage.coursePageActivityId &&
        next.coursePage.coursePageClassId === prev.coursePage.coursePageClassId &&
        next.coursePage.activityIdAfterAdd === prev.coursePage.activityIdAfterAdd &&
        next.coursePage.courseContentMenuType === prev.coursePage.courseContentMenuType &&
        next.login.identitiy.profileImagePath === prev.login.identitiy.profileImagePath &&
        next.profile.photoKey === prev.profile.photoKey &&
        next.login.identitiy.fullName === prev.login.identitiy.fullName &&
        next.coursePage.courseSortingKey === prev.coursePage.courseSortingKey &&
        next.login.identitiy.userType === prev.login.identitiy.userType &&
        next.coursePage.courseContentWeekActivities === prev.coursePage.courseContentWeekActivities &&
        next.coursePage.activityCard === prev.coursePage.activityCard &&
        next.coursePage.isPassiveButton === prev.coursePage.isPassiveButton &&
        next.coursePage.courseDefaultView === prev.coursePage.courseDefaultView
    );
    return ret;
};

const CActivityFilters = connect(
    mapStateToProps,
    dispatchProps,
    null,
    {
        areStatesEqual
    }
)(ActivityFilters);

export default CActivityFilters;